import { injectableExceptionHandler } from "./sentry/exception-handler.factory";
import { injectableLogHandler } from "./sentry/log-handler.factory";
import { module_name as qp_md_module_name } from "@qpUIs/qp-message-dialog/qp-message-dialog.module";
import 'angular-translate';
import { SentryServiceProvider } from "./sentry/sentry.provider";
import { envConfig } from "@env/env-config";

let module_name = "qp-logger"

angular.module(module_name, [qp_md_module_name])
    .provider({
        $sentry: SentryServiceProvider
    })
    .factory('$exceptionHandler', injectableExceptionHandler)
    .factory('$logger', injectableLogHandler)
    .config(["$sentryProvider", function (sentryServiceProvider: SentryServiceProvider) {
        sentryServiceProvider.config(envConfig.sentry);
    }]);

export { module_name }
